export const initialize = () => {
  // Add any future stateful actions here.
};

export const telemetry = (level, message, error) => {
  // Silence telemetry when running tests
  if (process.env.TESTING) return;

  // We can keep telemetry comments in the codebase without commenting them etc by using
  // telemetry.DISABLED.
  if (level === telemetry.DISABLED) return;

  // Silence debug statements when not running locally.
  if (!process.env.DECKEE_LOCAL_DEVELOPMENT && level === telemetry.DEBUG)
    return;

  // If this has been set, make sure the appropriate log level is being respected
  if (
    process.env.DECKEE_LOCAL_DEVELOPMENT &&
    process.env.DECKEE_LOCAL_LOG_LEVEL > level
  )
    return;

  /* eslint-disable no-bitwise */
  let consoleMethod;
  consoleMethod = telemetry.DEBUG & level ? 'log' : consoleMethod;
  consoleMethod = telemetry.INFO & level ? 'log' : consoleMethod;
  consoleMethod = telemetry.WARN & level ? 'log' : consoleMethod;
  consoleMethod = telemetry.ERROR & level ? 'error' : consoleMethod;
  /* eslint-enable no-bitwise */

  if (!consoleMethod) {
    // If the received level is not valid, then set it to error so that it is seen and hopefully
    // will be fixed.
    /* eslint-disable-next-line no-param-reassign */
    level = telemetry.ERROR;
    consoleMethod = 'error';
  }

  if (process.env.DECKEE_LOCAL_DEVELOPMENT) {
    const messageParsed =
      typeof message === 'string' ? message : JSON.stringify(message);
    const prefixes = {
      [telemetry.DEBUG]: '\x1b[34m[DEBUG]\x1b[0m',
      [telemetry.INFO]: '\x1b[36m[INFO]\x1b[0m',
      [telemetry.WARN]: '\x1b[35m[WARN]\x1b[0m',
      [telemetry.ERROR]: '\x1b[31m[ERROR]\x1b[0m',
    };
    const prefix = prefixes[level];
    /* eslint-disable-next-line no-console */
    console[consoleMethod](prefix, messageParsed);
    if (error) {
      /* eslint-disable-next-line no-console */
      console[consoleMethod](error);
    }
  }

  // NAMESPACE is baked into the container when built as we're running on the front-end, we need to
  // change this kind of configuration to a request which also picks up features etc.
  if (process.env.NAMESPACE === 'production') {
    // TODO: Build out a system to send this data back to our servers.
    /* eslint-disable-next-line no-console */
    // console[consoleMethod](`${prefix} ${messageParsed}`, error);
    // TODO: Future logging and telemetry functionality to be done here.
  }

  if (level >= telemetry.NOTIFY_SYSTEM) {
    // Handle notifications on the backend.
  }
};

// Use bitwise here for constants.
/* eslint-disable no-bitwise */
// Types
telemetry.DEBUG = 1 << 0;
telemetry.INFO = 1 << 1;
telemetry.WARN = 1 << 2;
telemetry.ERROR = 1 << 3;
telemetry.DISABLED = 1 << 4;
// Notification channels
telemetry.NOTIFY_SYSTEM_CHANNEL = 1 << 10;
telemetry.NOTIFY_FREEBOARD_CHANNEL = 1 << 11;
/* eslint-enable no-bitwise */
